import { render, staticRenderFns } from "./ViewProjectTypesModal.vue?vue&type=template&id=175b8f4a&scoped=true&"
import script from "./ViewProjectTypesModal.vue?vue&type=script&lang=js&"
export * from "./ViewProjectTypesModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "175b8f4a",
  null
  
)

export default component.exports